import directives from './directives';

export default new class Extend{
    public install = (Vue:any, options:any)=>{
        //载入指令
        Vue.use(directives);
    }
}()